import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-export-button',
  templateUrl: './export-button.component.html',
  styleUrls: ['./export-button.component.scss']
})
export class ExportButtonComponent implements OnInit {

  @Output() buttonClicked = new EventEmitter();
  @Input() disabled: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  onExportButtonClicked(): void {
    if (!this.disabled) {
      this.buttonClicked.emit();
    }
  }
}
